import React, { useEffect, useState } from "react"
import Grid       from '@mui/material/Grid'
import Box        from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper      from '@mui/material/Paper'
import '../../App.css'
import '../../style.css'

function CountDown({ onComplete, start = 3 }) {
    const [display, setDisplay] = useState(String(start))
    const [isStartText, setIsStartText] = useState(false)

    useEffect(() => {
        let isCancelled = false
        let timerId = null

        // 初期表示
        setDisplay(String(start))
        setIsStartText(false)

        // 3,2,1 を順に表示する配列を作成
        const nums = []
        for (let n = start; n >= 1; n--) nums.push(String(n))

        // 最後に「スタート！！」を追加
        const steps = [
        ...nums.map((t) => ({ text: t, ms: 1000, startText: false })),
        { text: "スタート！！", ms: 1000, startText: true },
        ]

        let idx = 0

        const runStep = () => {
        if (isCancelled) return

        const step = steps[idx]
        setDisplay(step.text)
        setIsStartText(step.startText)

        timerId = setTimeout(() => {
            if (isCancelled) return

            idx += 1
            if (idx >= steps.length) {
            onComplete?.() // Typingへ
            return
            }
            runStep()
        }, step.ms)
        }

        runStep()

        return () => {
        isCancelled = true
        if (timerId) clearTimeout(timerId)
        }
    }, [start, onComplete])

    return (
        <Box sx={{ m: 1, p: 4 }}>
        <Paper
            sx={{
            m: 1,
            p: 1,
            bgcolor      : '#f5f5dc',
            borderRadius : "1px",
            height       : "250px",
            width        : "250px",
            position     : "absolute",
            top          : "20px",
            left         : "40px",
            }}>
            <br/><br/><br/><br/>
            <Grid container spacing={0}>
            <Grid item xs={12} align="center">
                <Typography
                sx={{
                    fontFamily: "DotGothic16",
                    fontSize  : "30px",
                    fontWeight: "bold",
                    color     : isStartText ? "#DD0000" : "#000000",
                }}>
                {display}
                </Typography>
            </Grid>
            </Grid>
        </Paper>
        <Grid container spacing={2}>
            <Grid item xs={12} align="center"></Grid>
        </Grid>
        </Box>
    )
}

export default CountDown
